import { UserData } from './userData';

export enum FirebaseChapter {
  Westchester,
  Katy,
  Houston,
  Dallas,
  Fairfield,
  Boston,
  Vancouver,
  CookCounty,
  Seoul,
  Tokyo,
  BergenCounty,
}

export type FirebaseInstructorData = UserData & {
  bio: string;
  workshopAttended: boolean;
  static: {
    chapter: FirebaseChapter;
    classOf: number;
  };
};
